import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "application-structure"
    }}>{`Application Structure`}</h2>
    <pre><code parentName="pre" {...{}}>{`.
├── config                   # Project and build configurations
├── dist                     # Distribution folder
├── locales                  # Text files
├── logs                     # Log files
├── public                   # Static public assets and uploads
│   ├── admin                # Dashboard index.html
│   ├── admin-assets         # Dashboard assets
│   └── content              # Store root folder
|
├── scripts                  # Shell scripts for theme install/export
├── src                      # Application source code
│   ├── admin                # Dashboard application
│   │   └── client           # Client side code
│   ├── api                  # REST API
│   │   └── server           # Server side code
│   ├── store                # Store application
│   |   ├── client             # Client side code
│   |   ├── server             # Server side code
│   |   └── shared             # Universal code
│   └── index.js             # Server application start point
├── theme                    # Theme as a local package
└── process.json             # pm2 process file
`}</code></pre>
    <h3 {...{
      "id": "npm-scripts"
    }}>{`NPM Scripts`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="th">{`npm run <script>`}</inlineCode></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clean:admin`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete admin asset bundles.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clean:store`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete store asset bundles.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`compile:dev`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compiles the application to disk `}<strong parentName="td">{`and watch`}</strong>{` (`}<inlineCode parentName="td">{`~/dist`}</inlineCode>{` by default).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`compile`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compiles the application to disk (`}<inlineCode parentName="td">{`~/dist`}</inlineCode>{` by default).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`webpack:admin:dev`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Assemble admin bundles `}<strong parentName="td">{`and watch`}</strong>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`webpack:store:dev`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Assemble store bundles `}<strong parentName="td">{`and watch`}</strong>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`webpack:admin:prod`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Assemble admin bundles.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`webpack:store:prod`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Assemble store bundles.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`theme:install`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Install theme from /public/file.zip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`theme:export`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Zip current theme to /public/file.zip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`theme:copy`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compile theme and copy assets to /public/`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`theme:build:dev`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh theme after modification `}<strong parentName="td">{`and watch`}</strong>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`theme:build:prod`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh theme after modification.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`build:dev`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compile and assemble bundles `}<strong parentName="td">{`and watch`}</strong>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`build`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compile and assemble bundles.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`start`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Start node server.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      